import { render, staticRenderFns } from "./officialAccount.vue?vue&type=template&id=049ca22f&scoped=true"
import script from "./officialAccount.vue?vue&type=script&lang=js"
export * from "./officialAccount.vue?vue&type=script&lang=js"
import style0 from "./officialAccount.vue?vue&type=style&index=0&id=049ca22f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049ca22f",
  null
  
)

export default component.exports